import * as R from 'ramda'
import { normalize, denormalize } from 'normalizr'
import { transformUndefinedToSpecialKey, mergeObjectOrReplaceArray } from './utils'

type RootState = {
  api?: ConnectApiState
}

export type ConnectApiState = {
  [entity: string]: Entity
} & {
  __result: string
}

type Entity = {
  entities: object
}

function extractData(connectApiState: ConnectApiState, action) {
  if (typeof action.data === 'function') {
    const result = R.pipe(R.path(['__result', `${action.options.url}:${action.options.method}`]))(
      connectApiState
    )
    // @ts-ignore
    const entities = R.pipe(R.omit(['__result']), R.map(R.prop('entities')))(connectApiState)
    return action.data(denormalize(result, action.schema, entities))
  }

  return action.data
}

const connectApiReducer = (connectApiState, action) => {
  if (action.type === 'connectApi:RESET_STORE') {
    return {}
  }

  if (action.type === 'connectApi:SET_ENTITIES') {
    const data = extractData(connectApiState, action)
    const { options } = action
    if (data !== null) {
      const normalized = normalize(data, action.schema)

      const intermediateNextState = R.mergeDeepRight(
        connectApiState,
        // @ts-ignore
        R.pipe(transformUndefinedToSpecialKey, R.map(R.objOf('entities')))(normalized.entities)
      )

      return R.over(
        R.lensPath(['__result', `${options.url}:${options.method}`]),
        (previousResult) =>
          mergeObjectOrReplaceArray(
            previousResult,
            transformUndefinedToSpecialKey(normalized.result)
          ),
        intermediateNextState
      )
    } else {
      return R.set(
        R.lensPath(['__result', `${options.url}:${options.method}`]),
        null,
        connectApiState
      )
    }
  }

  return connectApiState
}

export const resetStore = () => ({
  type: 'connectApi:RESET_STORE',
})

export const enhanceReducer =
  (rootReducer) =>
  (state: RootState = {}, action) => {
    const nextState = rootReducer(R.dissoc('api')(state), action)
    const apiState = state.api || {}
    return R.assoc('api', connectApiReducer(apiState, action))(nextState)
  }



// WEBPACK FOOTER //
// ./src/libs/connectApi/store.ts